import { Injectable } from "@angular/core";
import { ApicallService } from "@core-services/apicall.service";
import { parseApiResponseObject2 } from "@helpers/functions";
import {
	CustodyAccountPreEligibilityResponse,
	CustodyAccountVerifiedEligibility,
	CustodyAccountVerifiedEligibilityResponse
} from "@modules/+new/custody_account/domain/entities/custody_account_eligibility.model";
import {
	CustodyAccountVerificationResponse,
	CustodyAccountVerificationStatus
} from "@modules/+new/custody_account/domain/entities/custody_account_verification.model";
import { EMPTY, Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";

@Injectable({
	providedIn: "root"
})
export class CustodyAccountRemote {
	private readonly basePath: string = "custody-account-management";
	constructor(private readonly apiCallService: ApicallService) {}

	public checkPreEligibility$(): Observable<boolean> {
		return this.apiCallService.get(`${this.basePath}/users/eligibility`).pipe(
			map((eligibilityResponse: CustodyAccountPreEligibilityResponse[]) =>
				parseApiResponseObject2<CustodyAccountPreEligibilityResponse>(eligibilityResponse)
			),
			map((eligibility: CustodyAccountPreEligibilityResponse) => eligibility.eligible),
			catchError(() => EMPTY)
		);
	}

	public checkCustodyAccountVerificationStatus$(): Observable<CustodyAccountVerificationStatus> {
		return this.apiCallService.get(`${this.basePath}/users/verification`).pipe(
			map((verificationResponse: CustodyAccountVerificationResponse[]) =>
				parseApiResponseObject2<CustodyAccountVerificationResponse>(verificationResponse)
			),
			map((verification: CustodyAccountVerificationResponse) => verification.verification_status),
			catchError(() => EMPTY)
		);
	}

	public checkVerifiedEligibility$(): Observable<CustodyAccountVerifiedEligibility> {
		return this.apiCallService.get(`${this.basePath}/users/eligibility`).pipe(
			map((verifiedEligibilityResponse: CustodyAccountVerifiedEligibilityResponse[]) =>
				parseApiResponseObject2<CustodyAccountVerifiedEligibilityResponse>(verifiedEligibilityResponse)
			),
			map(
				(verifiedEligibility: CustodyAccountVerifiedEligibilityResponse) =>
					verifiedEligibility.eligibility_status
			),
			catchError(() => EMPTY)
		);
	}
}
